// extracted by mini-css-extract-plugin
export default {"templateImage":"TemplateImage_templateImage__67DJB","faIcon":"TemplateImage_faIcon__IlwQu"};